import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import PublicHeader from "@/components/layout/PublicHeader";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { usePageSEO } from "@/hooks/use-seo";

const ServiceLevelAgreement = () => {
  const navigate = useNavigate();

  usePageSEO(
    "Service Level Agreement - Zoocertica",
    "Zoocertica SLA outlining uptime guarantees, support tiers, backups, and service credits for our wildlife management platform.",
    "/sla"
  );

  return (
    <div className="min-h-screen bg-background">
      <PublicHeader />
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-6"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>

        <Card>
          <CardHeader>
            <CardTitle className="text-3xl">Zoocertica Service Level Agreement (SLA)</CardTitle>
            <p className="text-sm text-muted-foreground">
              Updated October 2025
            </p>
          </CardHeader>
          <CardContent className="prose prose-sm max-w-none dark:prose-invert space-y-6">
            <section>
              <h2 className="text-xl font-semibold mb-3">1. Availability</h2>
              <p>
                99.9% uptime target monthly; excludes maintenance, emergencies, and third-party outages.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">2. Support Tiers</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Collector:</strong> M–F 9–5 EST (1-day response)</li>
                <li><strong>Zoo:</strong> M–F 9–6 EST (4-hour response)</li>
              </ul>
              <p className="mt-3">
                Email:{" "}
                <a href="mailto:support@zoocertica.com" className="text-primary hover:underline">
                  support@zoocertica.com
                </a>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">3. Backups & Recovery</h2>
              <p>
                Daily encrypted backups retained 7 days; recovery within 24h of verified loss.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">4. Service Credits</h2>
              <p>Credits:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>10% for 99.0–99.8%</li>
                <li>25% for 95.0–98.9%</li>
                <li>50% for &lt;95%</li>
              </ul>
              <p className="mt-3">Request within 15 days.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">5. Customer Responsibilities</h2>
              <p>
                Protect credentials; avoid misuse affecting uptime.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">6. Exclusions</h2>
              <p>
                SLA excludes free trials, beta features, and external causes.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">7. Amendments</h2>
              <p>
                We may update this SLA; see latest at{" "}
                <a href="https://zoocertica.com/sla" className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">
                  https://zoocertica.com/sla
                </a>.
              </p>
            </section>

            <div className="mt-8 p-4 bg-muted rounded-lg border">
              <p className="text-sm font-semibold text-center">
                THIS SLA IS SUBJECT TO THE TERMS OF SERVICE AND MAY BE UPDATED AT ANY TIME.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ServiceLevelAgreement;
